"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeleteCommentMutation = exports.useLazyCommentByIdQuery = exports.useAddOrUpdateCommentMutation = exports.useGetCommentListQuery = exports.CommentApi = void 0;
exports.UseDeleteComment = UseDeleteComment;
const react_1 = require("@reduxjs/toolkit/query/react");
const Utils_1 = require("../../Utils");
const user_api_1 = require("../user/user.api");
const http_1 = require("../../http");
const sweetalert2_1 = __importDefault(require("sweetalert2"));
const theme_1 = require("../../theme");
exports.CommentApi = (0, react_1.createApi)({
    reducerPath: "commentApi",
    tagTypes: ["comments", "commentById", "commentList"],
    baseQuery: (0, react_1.fetchBaseQuery)({
        baseUrl: `${http_1.ApiBaseUrl}`,
        prepareHeaders: user_api_1.prepareHeaders,
    }),
    endpoints: (builder) => ({
        getCommentList: builder.query({
            query: (query) => (0, Utils_1.QueryUrl)("comments/", query),
            providesTags: ["comments", "commentById", "commentList"],
        }),
        addOrUpdateComment: builder.mutation({
            invalidatesTags: ["comments", "commentById", "commentList"],
            query: ({ id, data }) => {
                if (id) {
                    return {
                        url: `comments/${id}/`,
                        method: "PUT",
                        body: data,
                    };
                }
                return {
                    url: `comments/`,
                    method: "POST",
                    body: data,
                };
            },
        }),
        commentById: builder.query({
            query: (id) => `comments/${id}/`,
            providesTags: ["commentById"],
        }),
        deleteComment: builder.mutation({
            invalidatesTags: ["comments", "commentById", "commentList"],
            query: (id) => ({
                url: `comments/${id}/`,
                method: "DELETE",
            }),
        }),
    })
});
exports.useGetCommentListQuery = exports.CommentApi.useGetCommentListQuery, exports.useAddOrUpdateCommentMutation = exports.CommentApi.useAddOrUpdateCommentMutation, exports.useLazyCommentByIdQuery = exports.CommentApi.useLazyCommentByIdQuery, exports.useDeleteCommentMutation = exports.CommentApi.useDeleteCommentMutation;
function UseDeleteComment(id) {
    const [deleteData] = (0, exports.useDeleteCommentMutation)();
    const onDelete = () => __awaiter(this, void 0, void 0, function* () {
        yield sweetalert2_1.default.fire({
            title: `Êtes-vous sûr de vouloir supprimer cette suggestion/remarque?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "OUI",
            cancelButtonText: "NON",
            showLoaderOnConfirm: true,
            iconColor: theme_1.Color.themeColor,
            confirmButtonColor: theme_1.Color.themeColor,
            preConfirm: () => {
                return deleteData(id);
            },
            allowOutsideClick: () => !sweetalert2_1.default.isLoading(),
        }).then((result) => {
            if (result === null || result === void 0 ? void 0 : result.value) {
                sweetalert2_1.default.fire({
                    icon: "success",
                    title: `Suggestion/remarque supprimée avec succès!`,
                    iconColor: theme_1.Color.themeColor,
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        });
    });
    return onDelete;
}
